import { Attribute, AttributeValue } from '@frontend/attribute/types';
import { IGroup } from '@frontend/group/types';
import { IProduct, ProductAttribute } from '@frontend/product/types';

export interface ShopScope {
    accountId: string;
    userId: string;
    functionalityId: string;
    rootCategoryId: string;
    orderWorkflowId: string | null;
    enforceCostCenterUse: boolean;
}

export interface ShopProduct extends IProduct {
    imageCategory?: Pick<IGroup, 'account_id' | 'id'>;
    productAttributes: ProductAttribute[];
    attributeValues: string[];
}

export interface ShopAttribute {
    attribute: Attribute;
    values: AttributeValue[];
}

export interface ShopCatalog {
    breadcrumbs: IGroup[];
    categories: IGroup[];
    products: ShopProduct[];
    attributes: ShopAttribute[];
}

export type ShopFilters = Record<string, string[]>;
export type ShopProductDisplay = 'list' | 'grid';

export interface ShopBasketItem {
    product: ShopProduct;
    quantity: number;
}

export interface ShopDraft {
    items: ShopBasketItem[];
    spotId: string | null;
    costCenterId: string | null;
    basketId: string | null;
    checkoutPending: boolean;
}

export const shopScopeKey = (scope: ShopScope): string =>
    JSON.stringify([scope.accountId, scope.userId, scope.functionalityId, scope.rootCategoryId, scope.orderWorkflowId, scope.enforceCostCenterUse]);
